import React from 'react'
export default function DateTime({ children }) {
  let result = ''

  if (typeof children === 'string') {
    const s = children.split('T')
    if (s.length === 2) {
      const d = s[0].split('-')
      const [ano, mes, dia] = d
      result = `${dia}/${mes}/${ano}`
    }
  }
  return <span>{result}</span>
}
